import { Injectable, signal } from '@angular/core';

export interface ToastMessage {
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly active = signal<ToastMessage | null>(null);
  private timer: ReturnType<typeof setTimeout> | null = null;

  show(message: string, type: ToastMessage['type'] = 'info', durationMs = 3000): void {
    if (this.timer) clearTimeout(this.timer);
    this.active.set({ message, type });
    this.timer = setTimeout(() => this.dismiss(), durationMs);
  }

  success(message: string): void {
    this.show(message, 'success');
  }

  error(message: string): void {
    this.show(message, 'error', 5000);
  }

  warning(message: string): void {
    this.show(message, 'warning', 4000);
  }

  info(message: string): void {
    this.show(message, 'info');
  }

  dismiss(): void {
    if (this.timer) clearTimeout(this.timer);
    this.active.set(null);
  }
}
